module.exports = __webpack_public_path__ + "img/image 08.f5de44e2.png";